// content.js 相关行为
import { AirEnum } from './base'

export enum CODE_ENUM {
  // 成功
  SUCCESS = 10000,
  // 失败
  ERROR = 10500,
  // 未找到
  NOT_FOUND = 404,
  // 禁止访问
  FORBIDDEN = 403,
  // 未授权
  onAuthorized = 401,
}

// 来源
export class BRIDGE_SOURCE extends AirEnum {
  static readonly MAIN = new BRIDGE_SOURCE('parent', '主页面')
  static readonly CHILD = new BRIDGE_SOURCE('child', '子页面')
}

// 系统提示
export class SYSTEM_NOTICE extends AirEnum {
  static readonly LANGUAGE_CHANGE = new SYSTEM_NOTICE(
    'SYSTEM_NOTICE/LANGUAGE_CHANGE',
    '语言变更',
    ['*']
  )
  static readonly LOGIN_SUCCESS = new SYSTEM_NOTICE(
    'SYSTEM_NOTICE/LOGIN_SUCCESS',
    '登录成功',
    ['*']
  )
  static readonly NOT_LOGIN = new SYSTEM_NOTICE(
    'SYSTEM_NOTICE/NOT_LOGIN',
    '未登录',
    ['*']
  )
}

// 系统权限
export class SYSTEM extends AirEnum {
  static readonly GET_SYSTEM_INFO = new SYSTEM('SYSTEM/REQUEST', '接口请求', [
    'request',
  ])
}

// 浏览器权限
export class BROWSER extends AirEnum {
  static readonly GET_BROWSER_INFO = new BROWSER(
    'BROWSER/GET_PARENT_USER',
    '获取浏览器信息',
    ['browser']
  )
}

// 生命周期
export class LIFE_CYCLE extends AirEnum {
  static readonly APP_SHOW = new LIFE_CYCLE(
    'LIFE_CYCLE/APP_SHOW',
    '应用显示',
    ['*'],
    1
  )
  static readonly APP_HIDE = new LIFE_CYCLE(
    'LIFE_CYCLE/APP_HIDE',
    '应用隐藏',
    ['*'],
    1
  )
  static readonly APP_DESTROY = new LIFE_CYCLE(
    'LIFE_CYCLE/APP_DESTROY',
    '应用销毁',
    ['*'],
    1
  )
}

// iframe的握手协议
export class IFRAME_HANDSHAKE extends AirEnum {
  static readonly CHILD_READY = new IFRAME_HANDSHAKE(
    'HANDSHAKE/CHILD_READY',
    '子应用准备就绪',
    ['*'],
    1
  )
  static readonly PARENT_ACK = new IFRAME_HANDSHAKE(
    'HANDSHAKE/PARENT_ACK',
    '父应用确认',
    ['*'],
    1
  )
}
